export default "__VITE_ASSET__DoKyd3Mq__"